import { getAppConfig } from 'app/getConfig';

export const selectReportApiUrl = () => getAppConfig().REPORT_API_CLIENT_URL;
export const selectAuthApiUrl = () => getAppConfig().AUTH_API_CLIENT_URL;
export const selectAIAvatarApiUrl = () => getAppConfig().AI_AVATAR_API_CLIENT_URL;
export const selectAISummaryApiUrl = () => getAppConfig().AI_SUMMARY_API_CLIENT_URL;
export const selectActApiUrl = () => getAppConfig().ACT_API_CLIENT_URL;
export const selectAuthUiUrl = () => getAppConfig().AUTH_UI_URL;
